// Value of the "All" chip. Hosts seed their own filter defaults from this so the
// chip row and the host agree on what "no category filter" means.
export const DEFAULT_CATEGORY = 'all'
